<div (offClick)="close()"
     [offClickOff]="!showOutlet">
    <div class="flex wrap p-t-2 p-b-2">
        <div class="w-12 flex flex-middle b-a b-col-12 pos-relative"
             [class.is-focus]="isFocus">
            <button class=""
                    type="button"
                    (click)="goToSearch()">
                <i class="flex icon-search2 p-r-1 col-11"
                   [style.font-size.px]="34"
                   aria-hidden="true"></i>
            </button>
            <input class="_input input p-l-0 p-r-0 no-focus b-a-0"
                   type="text"
                   #input
                   (focus)="isFocus = true"
                   [attr.placeholder]="showOutlet? 'What are you looking for?' : 'Search Barker and Stonehouse'"
                   [(ngModel)]="term"
                   (keyup)="keyup($event)">
            @if (status && status.busy) {
            <div class="pos-absolute z-2 bg-col-w top-0 left-1 bottom-0 flex flex-middle col-13">
                <i class="icon-loading"
                   [style.font-size.px]="26"></i>
            </div>
            }

            <button type="button"
                    (click)="close()"
                    class="z-1 flex flex-top w-2 flex-justify-center">
                <i [style.font-size.px]="14"
                   class="icon-close col-6"></i>
            </button>
        </div>
    </div>
    <div *afterContentInit
         [ngClass]="{'ng-hide': !showOutlet}"
         class="z-10 ng-hide ng-hide-animate hide-fade">
        <div class="bg-col-w col-b p-l overflow-y-auto no-scrollbar _open-search-outlet"
             style="height:100vh;">
            <open-search-outlet class="m-t-3 w-12"
                                [searchId]="searchId"
                                [contentBlockData]="contentBlockData"></open-search-outlet>
        </div>
    </div>
</div>
